import { render } from "./SiteViewers.vue?vue&type=template&id=fa800f8a"
import script from "./SiteViewers.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteViewers.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteViewers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa800f8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa800f8a', __exports__)) {
    api.reload('fa800f8a', __exports__)
  }
  
  module.hot.accept("./SiteViewers.vue?vue&type=template&id=fa800f8a", () => {
    api.rerender('fa800f8a', render)
  })

}


export default __exports__